import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-cancel-promo',
  templateUrl: './cancel-promo.page.html',
  styleUrls: ['./cancel-promo.page.scss'],
})
export class CancelPromoPage implements OnInit {

  @Input() isBonus = false;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  public onClose = (accept: boolean) => this.modalCtrl.dismiss(accept);

}
